<template>
  <section v-on:click="sectionClicked" class="textBlock features">
    <div class="sectionHeader" v-if="section.title || section.descriptions">
      <div class="cnt">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
        <a href="#" class="btn outline">Learn More</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  props: ['section'],
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.textBlock{
  .sectionHeader{
    text-align: center;
    z-index: 7;
    padding: 0 20px;
    @media (max-width: 680px) {
      padding: 0;
    }
    .sectionTitle{
      font-size: 46px;
      font-weight: 600;
      margin: 0 auto 16px;
      max-width: 700px;
      line-height: 1.3;
      @media (max-width: 1480px) {
        font-size: 36px;
      }
      @media (max-width: 960px) {
        font-size: 32px;
      }
      @media (max-width: 680px) {
        font-size: 26px;
        margin-bottom: 10px;
      }
    }
    .sectionDesc{
      color: inherit;
      margin: 0 auto;
      font-size: 20px;
      max-width: 860px;
      line-height: 1.5;
      padding: 0;
      @media (max-width: 1480px) {
        font-size: 18px;
      }
      @media (max-width: 680px) {
        font-size: 16px;
        line-height: 1.3;
      }
    }
    .btn{
      font-size: 20px;
      font-weight: 400;
      margin: 30px 0 0;
      display: inline-block;
    }
  }
}
</style>
